import styled from 'styled-components';
import { container, screen, spacing } from '../../../theme';

export const StyledTeamSection = styled.div`
  margin: auto;
  margin-top: ${spacing('md')};
  max-width: ${container('sm')};

  @media (min-width: ${screen('md')}) {
    margin-top: ${spacing('xl')};
  }

  @media (min-width: ${screen('lg')}) {
    margin-top: ${spacing('xl3')};
  }

  ul,
  ol,
  p {
    margin-top: 0;
    margin-bottom: ${spacing('xl')};
    line-height: 1.5;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
